import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'application';

export const TEST_ID = 'applicationSelectPanelField';
